module.exports = __webpack_public_path__ + "static/media/Portrait-10214.6944ee24.jpg";